import { scrollIntoView, getUrlVars, isMobileView } from '/Assets/js/common/utilities.js';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.block-foldable-content')) {
    new FoldableContent();
  }
});

class FoldableContent {
  constructor() {
    this.init();
    this.openSection();
  }

  init() {
    const foldableTitles = document.querySelectorAll('.block-foldable-content .foldable-title');

    foldableTitles.forEach((title) => {
      const btnTitle = title.querySelector('h4');

      if (btnTitle) {
        btnTitle.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            title.click();
          }
        });
      }

      title.addEventListener('click', () => {
        const parentBlock = title.closest('.block-foldable-content');

        if (parentBlock) {
          parentBlock.classList.toggle('open');
        }

        if (!btnTitle) {
          return;
        }

        const headerBtn = btnTitle.querySelector('button');
        if (!headerBtn) {
          return;
        }
        const isExpanded = headerBtn.getAttribute('aria-expanded') === 'true';
        headerBtn.setAttribute('aria-expanded', (!isExpanded).toString());
      });
    });
  }

  openSection() {
    const qs = getUrlVars();
    const section = qs['section'] ? qs['section'] : qs['Section'];

    if (section === null) {
      return;
    }

    const isMobileVal = isMobileView();
    const offset = isMobileVal ? 0 : 75;
    const element = document.getElementById(section);
    if (element && !element.classList.contains('anchor')) {
      element.classList.add('open');
    }
    scrollIntoView(element, { behavior: 'smooth', block: 'center' }, offset);
  }
}
